import i18next from 'i18next';
import { readVarM } from '../../Assertions/environments';

export const rootLink = () =>
  ({
    rel: 'self',
    href:
      readVarM('VITE_API_ROOT').getOrElseValue('') +
      `/self_service/roots.json?lng=${i18next.language}`,
    endpoint: '/roots',
    method: 'get',
    type: 'application/json',
  }) as const;
